import React, { useState } from "react";
import { Globe, ChevronDown, Copy } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const cleanDomain = (v) =>
  (v || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/.*$/, "")
    .replace(/[^a-z0-9.-]/g, "");

// Dominio propio: el cliente reenvía su dominio (GoDaddy, Hostinger...) a su portafolio.
export const CustomDomainField = ({ value, onChange, targetUrl, onCopy }) => {
  const [open, setOpen] = useState(false);
  const dom = cleanDomain(value);
  return (
    <div className="space-y-2 rounded-lg bg-slate-50 p-3" data-testid="custom-domain-box">
      <Label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
        <Globe className="h-3.5 w-3.5" /> Dominio propio (página web)
      </Label>
      <Input
        value={value || ""}
        onChange={(e) => onChange(cleanDomain(e.target.value))}
        placeholder="ej. cafeaurora.com"
        data-testid="custom-domain-input"
      />
      <div className="flex items-center gap-2">
        <p className="flex-1 truncate rounded-md bg-white px-2 py-1.5 text-xs text-slate-600">{targetUrl}</p>
        <button
          type="button"
          onClick={() => onCopy(targetUrl)}
          className="flex items-center gap-1 rounded-md bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700"
          data-testid="custom-domain-copy"
        >
          <Copy className="h-3.5 w-3.5" /> Copiar destino
        </button>
      </div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between text-xs font-semibold text-blue-600"
        data-testid="custom-domain-help"
      >
        Cómo conectar {dom || "el dominio"} paso a paso
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ol className="list-decimal space-y-1.5 pl-4 text-[12px] leading-snug text-slate-600">
          <li>Entra a donde compraste el dominio (GoDaddy, Hostinger, Namecheap, Google/Squarespace…).</li>
          <li>Abre <b>{dom || "tu dominio"}</b> y busca la opción <b>“Reenvío”, “Redirección” o “Forwarding”</b>.</li>
          <li>Pega como destino el enlace de arriba (botón <b>Copiar destino</b>).</li>
          <li>Elige tipo <b>Permanente (301)</b>. Si aparece <b>“con enmascaramiento / masking”</b>, actívalo para que siga viéndose {dom || "tu dominio"} en la barra.</li>
          <li>Guarda. En 5–30 minutos, al abrir {dom || "tu dominio"} se verá el portafolio como página web.</li>
        </ol>
      )}
    </div>
  );
};
